export enum AiWorkflowTypesApiEnum {
    BRAND_IDENTITY = 'BRAND_IDENTITY'
}
